import React from 'react';
import { Box, Typography } from '@mui/material';
import rip from "../assets/rip.png";
const PageNotFound = () => {
    return (
        <Box sx={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", backgroundColor: "#fff" }}>
            <img loading='lazy' src={rip} alt="rip" style={{ objectFit: "cover" }} />
            <Typography variant="h1" sx={{ color: "#d32f2f", fontSize: "30px", fontWeight: "bold" }}>404 Not Found</Typography>
        </Box>
    );
};

export default PageNotFound;